// Api
import AxiosClient from '@api/axiosClient';
// Models
import { IPostProvisionBody } from '@models/Provisions';
// Urls
import { urls } from './urls';

export const apiPostProvisions = (body: IPostProvisionBody): Promise<unknown> =>
    AxiosClient.post(urls.payslip.provisions.main, body);
